var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72201 3C9.84601 3 11.489 4.862 11.226 6.969L11.094 8.023C10.881 9.724 9.43601 11 7.72201 11C6.00801 11 4.56201 9.724 4.35001 8.023L4.21801 6.969C3.95501 4.861 5.59801 3 7.72201 3Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.574 2C19.421 2 20.84 3.636 20.579 5.465L20.428 6.525C20.225 7.945 19.009 9 17.574 9C16.14 9 14.923 7.945 14.72 6.525L14.569 5.465C14.308 3.636 15.727 2 17.574 2Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00395 14.618C6.14895 13.793 9.29495 13.793 12.44 14.618C13.21 14.82 13.797 15.45 13.928 16.235L14.417 19.169C14.593 20.223 13.909 21.241 12.863 21.46C9.43595 22.179 6.00795 22.179 2.58095 21.46C1.53495 21.24 0.851954 20.223 1.02695 19.169L1.51595 16.235C1.64695 15.45 2.23295 14.82 3.00395 14.618Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.416 18.967C19.716 18.895 21.016 18.664 22.317 18.257C22.763 18.117 23.042 17.67 22.996 17.205L22.638 13.624C22.6 13.243 22.349 12.906 21.987 12.779C19.978 12.07 17.969 11.857 15.96 12.117",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDouble);
export default __webpack_public_path__ + "static/media/user-double.b2fb185c2929f5b7e7a143b0203f7e22.svg";
export { ForwardRef as ReactComponent };